export const PROD_API = `${process.env.REACT_APP_SERVER_HOST_URL}`